module.exports = __webpack_public_path__ + "static/img/11.d216ae4f.jpg";